"use strict";
const charTable = {
    ascii: {
        0x21: [0x81, 0x49],
        0x22: [0x81, 0x68],
        0x23: [0x81, 0x94],
        0x24: [0x81, 0x90],
        0x25: [0x81, 0x93],
        0x26: [0x81, 0x95],
        0x27: [0x81, 0x66],
        0x28: [0x81, 0x69],
        0x29: [0x81, 0x6A],
        0x2A: [0x81, 0x96],
        0x2B: [0x81, 0x7B],
        0x2C: [0x81, 0x43],
        0x2D: [0x81, 0x7C],
        0x2E: [0x81, 0x44],
        0x2F: [0x81, 0x5E],
        0x30: [0x82, 0x4F],
        0x31: [0x82, 0x50],
        0x32: [0x82, 0x51],
        0x33: [0x82, 0x52],
        0x34: [0x82, 0x53],
        0x35: [0x82, 0x54],
        0x36: [0x82, 0x55],
        0x37: [0x82, 0x56],
        0x38: [0x82, 0x57],
        0x39: [0x82, 0x58],
        0x3A: [0x81, 0x46],
        0x3B: [0x81, 0x47],
        0x3C: [0x81, 0x83],
        0x3D: [0x81, 0x81],
        0x3E: [0x81, 0x84],
        0x3F: [0x81, 0x48],
        0x40: [0x81, 0x97],
        0x41: [0x82, 0x60],
        0x42: [0x82, 0x61],
        0x43: [0x82, 0x62],
        0x44: [0x82, 0x63],
        0x45: [0x82, 0x64],
        0x46: [0x82, 0x65],
        0x47: [0x82, 0x66],
        0x48: [0x82, 0x67],
        0x49: [0x82, 0x68],
        0x4A: [0x82, 0x69],
        0x4B: [0x82, 0x6A],
        0x4C: [0x82, 0x6B],
        0x4D: [0x82, 0x6C],
        0x4E: [0x82, 0x6D],
        0x4F: [0x82, 0x6E],
        0x50: [0x82, 0x6F],
        0x51: [0x82, 0x70],
        0x52: [0x82, 0x71],
        0x53: [0x82, 0x72],
        0x54: [0x82, 0x73],
        0x55: [0x82, 0x74],
        0x56: [0x82, 0x75],
        0x57: [0x82, 0x76],
        0x58: [0x82, 0x77],
        0x59: [0x82, 0x78],
        0x5A: [0x82, 0x79],
        0x5B: [0x81, 0x6D],
        0x5C: [0x81, 0x8F],
        0x5D: [0x81, 0x6E],
        0x5E: [0x81, 0x4F],
        0x5F: [0x81, 0x51],
        0x60: [0x81, 0x65],
        0x61: [0x82, 0x81],
        0x62: [0x82, 0x82],
        0x63: [0x82, 0x83],
        0x64: [0x82, 0x84],
        0x65: [0x82, 0x85],
        0x66: [0x82, 0x86],
        0x67: [0x82, 0x87],
        0x68: [0x82, 0x88],
        0x69: [0x82, 0x89],
        0x6A: [0x82, 0x8A],
        0x6B: [0x82, 0x8B],
        0x6C: [0x82, 0x8C],
        0x6D: [0x82, 0x8D],
        0x6E: [0x82, 0x8E],
        0x6F: [0x82, 0x8F],
        0x70: [0x82, 0x90],
        0x71: [0x82, 0x91],
        0x72: [0x82, 0x92],
        0x73: [0x82, 0x93],
        0x74: [0x82, 0x94],
        0x75: [0x82, 0x95],
        0x76: [0x82, 0x96],
        0x77: [0x82, 0x97],
        0x78: [0x82, 0x98],
        0x79: [0x82, 0x99],
        0x7A: [0x82, 0x9A],
        0x7B: [0x81, 0x6F],
        0x7C: [0x81, 0x62],
        0x7D: [0x81, 0x70],
        0x7E: [0x81, 0x50]
    },
    hiragana: {
        0x21: [0x82, 0x9F],
        0x22: [0x82, 0xA0],
        0x23: [0x82, 0xA1],
        0x24: [0x82, 0xA2],
        0x25: [0x82, 0xA3],
        0x26: [0x82, 0xA4],
        0x27: [0x82, 0xA5],
        0x28: [0x82, 0xA6],
        0x29: [0x82, 0xA7],
        0x2A: [0x82, 0xA8],
        0x2B: [0x82, 0xA9],
        0x2C: [0x82, 0xAA],
        0x2D: [0x82, 0xAB],
        0x2E: [0x82, 0xAC],
        0x2F: [0x82, 0xAD],
        0x30: [0x82, 0xAE],
        0x31: [0x82, 0xAF],
        0x32: [0x82, 0xB0],
        0x33: [0x82, 0xB1],
        0x34: [0x82, 0xB2],
        0x35: [0x82, 0xB3],
        0x36: [0x82, 0xB4],
        0x37: [0x82, 0xB5],
        0x38: [0x82, 0xB6],
        0x39: [0x82, 0xB7],
        0x3A: [0x82, 0xB8],
        0x3B: [0x82, 0xB9],
        0x3C: [0x82, 0xBA],
        0x3D: [0x82, 0xBB],
        0x3E: [0x82, 0xBC],
        0x3F: [0x82, 0xBD],
        0x40: [0x82, 0xBE],
        0x41: [0x82, 0xBF],
        0x42: [0x82, 0xC0],
        0x43: [0x82, 0xC1],
        0x44: [0x82, 0xC2],
        0x45: [0x82, 0xC3],
        0x46: [0x82, 0xC4],
        0x47: [0x82, 0xC5],
        0x48: [0x82, 0xC6],
        0x49: [0x82, 0xC7],
        0x4A: [0x82, 0xC8],
        0x4B: [0x82, 0xC9],
        0x4C: [0x82, 0xCA],
        0x4D: [0x82, 0xCB],
        0x4E: [0x82, 0xCC],
        0x4F: [0x82, 0xCD],
        0x50: [0x82, 0xCE],
        0x51: [0x82, 0xCF],
        0x52: [0x82, 0xD0],
        0x53: [0x82, 0xD1],
        0x54: [0x82, 0xD2],
        0x55: [0x82, 0xD3],
        0x56: [0x82, 0xD4],
        0x57: [0x82, 0xD5],
        0x58: [0x82, 0xD6],
        0x59: [0x82, 0xD7],
        0x5A: [0x82, 0xD8],
        0x5B: [0x82, 0xD9],
        0x5C: [0x82, 0xDA],
        0x5D: [0x82, 0xDB],
        0x5E: [0x82, 0xDC],
        0x5F: [0x82, 0xDD],
        0x60: [0x82, 0xDE],
        0x61: [0x82, 0xDF],
        0x62: [0x82, 0xE0],
        0x63: [0x82, 0xE1],
        0x64: [0x82, 0xE2],
        0x65: [0x82, 0xE3],
        0x66: [0x82, 0xE4],
        0x67: [0x82, 0xE5],
        0x68: [0x82, 0xE6],
        0x69: [0x82, 0xE7],
        0x6A: [0x82, 0xE8],
        0x6B: [0x82, 0xE9],
        0x6C: [0x82, 0xEA],
        0x6D: [0x82, 0xEB],
        0x6E: [0x82, 0xEC],
        0x6F: [0x82, 0xED],
        0x70: [0x82, 0xEE],
        0x71: [0x82, 0xEF],
        0x72: [0x82, 0xF0],
        0x73: [0x82, 0xF1],
        0x74: [0x81, 0x40],
        0x75: [0x81, 0x40],
        0x76: [0x81, 0x40],
        0x77: [0x81, 0x54],
        0x78: [0x81, 0x55],
        0x79: [0x81, 0x5B],
        0x7A: [0x81, 0x42],
        0x7B: [0x81, 0x75],
        0x7C: [0x81, 0x76],
        0x7D: [0x81, 0x41],
        0x7E: [0x81, 0x45]
    },
    katakana: {
        0x21: [0x83, 0x40],
        0x22: [0x83, 0x41],
        0x23: [0x83, 0x42],
        0x24: [0x83, 0x43],
        0x25: [0x83, 0x44],
        0x26: [0x83, 0x45],
        0x27: [0x83, 0x46],
        0x28: [0x83, 0x47],
        0x29: [0x83, 0x48],
        0x2A: [0x83, 0x49],
        0x2B: [0x83, 0x4A],
        0x2C: [0x83, 0x4B],
        0x2D: [0x83, 0x4C],
        0x2E: [0x83, 0x4D],
        0x2F: [0x83, 0x4E],
        0x30: [0x83, 0x4F],
        0x31: [0x83, 0x50],
        0x32: [0x83, 0x51],
        0x33: [0x83, 0x52],
        0x34: [0x83, 0x53],
        0x35: [0x83, 0x54],
        0x36: [0x83, 0x55],
        0x37: [0x83, 0x56],
        0x38: [0x83, 0x57],
        0x39: [0x83, 0x58],
        0x3A: [0x83, 0x59],
        0x3B: [0x83, 0x5A],
        0x3C: [0x83, 0x5B],
        0x3D: [0x83, 0x5C],
        0x3E: [0x83, 0x5D],
        0x3F: [0x83, 0x5E],
        0x40: [0x83, 0x5F],
        0x41: [0x83, 0x60],
        0x42: [0x83, 0x61],
        0x43: [0x83, 0x62],
        0x44: [0x83, 0x63],
        0x45: [0x83, 0x64],
        0x46: [0x83, 0x65],
        0x47: [0x83, 0x66],
        0x48: [0x83, 0x67],
        0x49: [0x83, 0x68],
        0x4A: [0x83, 0x69],
        0x4B: [0x83, 0x6A],
        0x4C: [0x83, 0x6B],
        0x4D: [0x83, 0x6C],
        0x4E: [0x83, 0x6D],
        0x4F: [0x83, 0x6E],
        0x50: [0x83, 0x6F],
        0x51: [0x83, 0x70],
        0x52: [0x83, 0x71],
        0x53: [0x83, 0x72],
        0x54: [0x83, 0x73],
        0x55: [0x83, 0x74],
        0x56: [0x83, 0x75],
        0x57: [0x83, 0x76],
        0x58: [0x83, 0x77],
        0x59: [0x83, 0x78],
        0x5A: [0x83, 0x79],
        0x5B: [0x83, 0x7A],
        0x5C: [0x83, 0x7B],
        0x5D: [0x83, 0x7C],
        0x5E: [0x83, 0x7D],
        0x5F: [0x83, 0x7E],
        0x60: [0x83, 0x80],
        0x61: [0x83, 0x81],
        0x62: [0x83, 0x82],
        0x63: [0x83, 0x83],
        0x64: [0x83, 0x84],
        0x65: [0x83, 0x85],
        0x66: [0x83, 0x86],
        0x67: [0x83, 0x87],
        0x68: [0x83, 0x88],
        0x69: [0x83, 0x89],
        0x6A: [0x83, 0x8A],
        0x6B: [0x83, 0x8B],
        0x6C: [0x83, 0x8C],
        0x6D: [0x83, 0x8D],
        0x6E: [0x83, 0x8E],
        0x6F: [0x83, 0x8F],
        0x70: [0x83, 0x90],
        0x71: [0x83, 0x91],
        0x72: [0x83, 0x92],
        0x73: [0x83, 0x93],
        0x74: [0x83, 0x94],
        0x75: [0x83, 0x95],
        0x76: [0x83, 0x96],
        0x77: [0x81, 0x52],
        0x78: [0x81, 0x53],
        0x79: [0x81, 0x5B],
        0x7A: [0x81, 0x42],
        0x7B: [0x81, 0x75],
        0x7C: [0x81, 0x76],
        0x7D: [0x81, 0x41],
        0x7E: [0x81, 0x45]
    },
    gaiji_1: {
        0x7A4D: [49, 48, 46],
        0x7A4E: [49, 49, 46],
        0x7A4F: [49, 50, 46],
        0x7A50: [91, 72, 86, 93],
        0x7A51: [91, 83, 68, 93],
        0x7A52: [91, 130, 111, 93],
        0x7A53: [91, 130, 118, 93],
        0x7A54: [91, 77, 86, 93],
        0x7A55: [91, 142, 232, 93],
        0x7A56: [91, 142, 154, 93],
        0x7A57: [91, 145, 111, 93],
        0x7A58: [91, 131, 102, 93],
        0x7A59: [91, 130, 114, 93],
        0x7A5A: [91, 147, 241, 93],
        0x7A5B: [91, 145, 189, 93],
        0x7A5C: [91, 137, 240, 93],
        0x7A5D: [91, 83, 83, 93],
        0x7A5E: [91, 130, 97, 93],
        0x7A5F: [91, 130, 109, 93],
        0x7A60: [129, 161],
        0x7A61: [129, 156],
        0x7A62: [91, 147, 86, 93],
        0x7A63: [91, 140, 240, 93],
        0x7A64: [91, 137, 102, 93],
        0x7A65: [91, 150, 179, 93],
        0x7A66: [91, 151, 191, 93],
        0x7A67: [91, 129, 69, 93],
        0x7A68: [91, 145, 79, 93],
        0x7A69: [91, 140, 227, 93],
        0x7A6A: [91, 141, 196, 93],
        0x7A6B: [91, 144, 86, 93],
        0x7A6C: [91, 143, 137, 93],
        0x7A6D: [91, 143, 73, 93],
        0x7A6E: [91, 144, 182, 93],
        0x7A6F: [91, 148, 204, 93],
        0x7A70: [91, 144, 186, 93],
        0x7A71: [91, 144, 129, 93],
        0x7A72: [91, 80, 80, 86, 93],
        0x7A73: [40, 148, 233, 41],
        0x7A74: [130, 217, 130, 169],
        0x7C21: [129, 168],
        0x7C22: [129, 169],
        0x7C23: [129, 170],
        0x7C24: [129, 171],
        0x7C25: [129, 69],
        0x7C26: [129, 69],
        0x7C27: [148, 78],
        0x7C28: [140, 142],
        0x7C29: [147, 250],
        0x7C2A: [137, 126],
        0x7C2B: [109, 94, 50],
        0x7C2C: [109, 94, 51],
        0x7C2D: [99, 109],
        0x7C2E: [99, 109, 94, 50],
        0x7C2F: [99, 109, 94, 51],
        0x7C30: [130, 79, 46],
        0x7C31: [130, 80, 46],
        0x7C32: [130, 81, 46],
        0x7C33: [130, 82, 46],
        0x7C34: [130, 83, 46],
        0x7C35: [130, 84, 46],
        0x7C36: [130, 85, 46],
        0x7C37: [130, 86, 46],
        0x7C38: [130, 87, 46],
        0x7C39: [130, 88, 46],
        0x7C3A: [142, 129],
        0x7C3B: [149, 155],
        0x7C3C: [140, 179],
        0x7C3D: [140, 204],
        0x7C3E: [145, 79],
        0x7C3F: [140, 227],
        0x7C40: [130, 79, 44],
        0x7C41: [130, 80, 44],
        0x7C42: [130, 81, 44],
        0x7C43: [130, 82, 44],
        0x7C44: [130, 83, 44],
        0x7C45: [130, 84, 44],
        0x7C46: [130, 85, 44],
        0x7C47: [130, 86, 44],
        0x7C48: [130, 87, 44],
        0x7C49: [130, 88, 44],
        0x7C4A: [91, 142, 208, 93],
        0x7C4B: [91, 141, 224, 93],
        0x7C4C: [91, 151, 76, 93],
        0x7C4D: [91, 138, 148, 93],
        0x7C4E: [91, 145, 227, 93],
        0x7C4F: [40, 150, 226, 41],
        0x7C50: [129, 69],
        0x7C51: [129, 69],
        0x7C52: [129, 69],
        0x7C53: [129, 69],
        0x7C54: [129, 69],
        0x7C55: [129, 69],
        0x7C56: [129, 69],
        0x7C57: [40, 67, 68, 41],
        0x7C58: [40, 118, 110, 41],
        0x7C59: [40, 111, 98, 41],
        0x7C5A: [40, 99, 98, 41],
        0x7C5B: [40, 99, 101],
        0x7C5C: [109, 98, 41],
        0x7C5D: [40, 104, 112, 41],
        0x7C5E: [40, 98, 114, 41],
        0x7C5F: [40, 130, 144, 41],
        0x7C60: [40, 130, 147, 41],
        0x7C61: [40, 109, 115, 41],
        0x7C62: [40, 130, 148, 41],
        0x7C63: [40, 98, 115, 41],
        0x7C64: [40, 130, 130, 41],
        0x7C65: [40, 116, 98, 41],
        0x7C66: [40, 116, 112, 41],
        0x7C67: [40, 100, 115, 41],
        0x7C68: [40, 97, 103, 41],
        0x7C69: [40, 101, 103, 41],
        0x7C6A: [40, 118, 111, 41],
        0x7C6B: [40, 102, 108, 41],
        0x7C6C: [40, 107, 101],
        0x7C6D: [121, 41],
        0x7C6E: [40, 115, 97],
        0x7C6F: [120, 41],
        0x7C70: [40, 115, 121],
        0x7C71: [110, 41],
        0x7C72: [40, 111, 114],
        0x7C73: [103, 41],
        0x7C74: [40, 112, 101],
        0x7C75: [114, 41],
        0x7C76: [40, 130, 113, 41],
        0x7C77: [40, 130, 98, 41],
        0x7C78: [40, 226, 181, 41],
        0x7C79: [130, 99, 130, 105],
        0x7C7A: [91, 137, 137, 93],
        0x7C7B: [70, 97, 120],
        0x7D21: [40, 140, 142, 41],
        0x7D22: [40, 137, 206, 41],
        0x7D23: [40, 144, 133, 41],
        0x7D24: [40, 150, 216, 41],
        0x7D25: [40, 139, 224, 41],
        0x7D26: [40, 147, 121, 41],
        0x7D27: [40, 147, 250, 41],
        0x7D28: [40, 143, 106, 41],
        0x7D29: [135, 141],
        0x7D2A: [135, 142],
        0x7D2B: [135, 143],
        0x7D2C: [135, 126],
        0x7D2D: [78, 111, 46],
        0x7D2E: [84, 101, 108],
        0x7D2F: [40, 129, 167, 41],
        0x7D30: [40, 41, 40, 41],
        0x7D31: [91, 150, 123, 93],
        0x7D32: [91, 142, 79, 93],
        0x7D33: [91, 147, 241, 93],
        0x7D34: [91, 136, 192, 93],
        0x7D35: [91, 147, 95, 93],
        0x7D36: [91, 145, 197, 93],
        0x7D37: [91, 147, 144, 93],
        0x7D38: [91, 143, 159, 93],
        0x7D39: [91, 148, 115, 93],
        0x7D3A: [91, 130, 114, 93],
        0x7D3B: [91, 147, 138, 93],
        0x7D3C: [91, 149, 223, 93],
        0x7D3D: [91, 136, 234, 93],
        0x7D3E: [91, 147, 241, 93],
        0x7D3F: [91, 142, 79, 93],
        0x7D40: [91, 151, 86, 93],
        0x7D41: [91, 141, 182, 93],
        0x7D42: [91, 146, 134, 93],
        0x7D43: [91, 137, 69, 93],
        0x7D44: [91, 142, 119, 93],
        0x7D45: [91, 145, 150, 93],
        0x7D46: [91, 145, 197, 93],
        0x7D47: [108],
        0x7D48: [107, 103],
        0x7D49: [72, 122],
        0x7D4A: [104, 97],
        0x7D4B: [107, 109],
        0x7D4C: [107, 109, 94, 50],
        0x7D4D: [104, 80, 97],
        0x7D4E: [129, 69],
        0x7D4F: [129, 69],
        0x7D50: [49, 47, 50],
        0x7D51: [48, 47, 51],
        0x7D52: [49, 47, 51],
        0x7D53: [50, 47, 51],
        0x7D54: [49, 47, 52],
        0x7D55: [51, 47, 52],
        0x7D56: [49, 47, 53],
        0x7D57: [50, 47, 53],
        0x7D58: [51, 47, 53],
        0x7D59: [52, 47, 53],
        0x7D5A: [49, 47, 54],
        0x7D5B: [53, 47, 54],
        0x7D5C: [49, 47, 55],
        0x7D5D: [49, 47, 56],
        0x7D5E: [49, 47, 57],
        0x7D5F: [49, 47, 49, 48],
        0x7D6E: [33, 33],
        0x7D6F: [33, 63],
        0x7E21: [135, 84],
        0x7E22: [135, 85],
        0x7E23: [135, 86],
        0x7E24: [135, 87],
        0x7E25: [135, 88],
        0x7E26: [135, 89],
        0x7E27: [135, 90],
        0x7E28: [135, 91],
        0x7E29: [135, 92],
        0x7E2A: [135, 93],
        0x7E2B: [88, 73],
        0x7E2C: [88, 73, 73],
        0x7E2D: [135, 80],
        0x7E2E: [135, 81],
        0x7E2F: [135, 82],
        0x7E30: [135, 83],
        0x7E31: [40, 130, 80, 41],
        0x7E32: [40, 130, 81, 41],
        0x7E33: [40, 130, 82, 41],
        0x7E34: [40, 130, 83, 41],
        0x7E35: [40, 130, 84, 41],
        0x7E36: [40, 130, 85, 41],
        0x7E37: [40, 130, 86, 41],
        0x7E38: [40, 130, 87, 41],
        0x7E39: [40, 130, 88, 41],
        0x7E3A: [40, 49, 48, 41],
        0x7E3B: [40, 49, 49, 41],
        0x7E3C: [40, 49, 50, 41],
        0x7E3D: [40, 50, 49, 41],
        0x7E3E: [40, 50, 50, 41],
        0x7E3F: [40, 50, 51, 41],
        0x7E40: [40, 50, 52, 41],
        0x7E41: [40, 130, 96, 41],
        0x7E42: [40, 130, 97, 41],
        0x7E43: [40, 130, 98, 41],
        0x7E44: [40, 130, 99, 41],
        0x7E45: [40, 130, 100, 41],
        0x7E46: [40, 130, 101, 41],
        0x7E47: [40, 130, 102, 41],
        0x7E48: [40, 130, 103, 41],
        0x7E49: [40, 130, 104, 41],
        0x7E4A: [40, 130, 105, 41],
        0x7E4B: [40, 130, 106, 41],
        0x7E4C: [40, 130, 107, 41],
        0x7E4D: [40, 130, 108, 41],
        0x7E4E: [40, 130, 109, 41],
        0x7E4F: [40, 130, 110, 41],
        0x7E50: [40, 130, 111, 41],
        0x7E51: [40, 130, 112, 41],
        0x7E52: [40, 130, 113, 41],
        0x7E53: [40, 130, 114, 41],
        0x7E54: [40, 130, 115, 41],
        0x7E55: [40, 130, 116, 41],
        0x7E56: [40, 130, 117, 41],
        0x7E57: [40, 130, 118, 41],
        0x7E58: [40, 130, 119, 41],
        0x7E59: [40, 130, 120, 41],
        0x7E5A: [40, 130, 121, 41],
        0x7E5B: [40, 50, 53, 41],
        0x7E5C: [40, 50, 54, 41],
        0x7E5D: [40, 50, 55, 41],
        0x7E5E: [40, 50, 56, 41],
        0x7E5F: [40, 50, 57, 41],
        0x7E60: [40, 51, 48, 41],
        0x7E61: [135, 64],
        0x7E62: [135, 65],
        0x7E63: [135, 66],
        0x7E64: [135, 67],
        0x7E65: [135, 68],
        0x7E66: [135, 69],
        0x7E67: [135, 70],
        0x7E68: [135, 71],
        0x7E69: [135, 72],
        0x7E6A: [135, 73],
        0x7E6B: [135, 74],
        0x7E6C: [135, 75],
        0x7E6D: [135, 76],
        0x7E6E: [135, 77],
        0x7E6F: [135, 78],
        0x7E70: [135, 79],
        0x7E71: [40, 130, 80, 41],
        0x7E72: [40, 130, 81, 41],
        0x7E73: [40, 130, 82, 41],
        0x7E74: [40, 130, 83, 41],
        0x7E75: [40, 130, 84, 41],
        0x7E76: [40, 130, 85, 41],
        0x7E77: [40, 130, 86, 41],
        0x7E78: [40, 130, 87, 41],
        0x7E79: [40, 130, 88, 41],
        0x7E7A: [40, 49, 48, 41],
        0x7E7B: [40, 49, 49, 41],
        0x7E7C: [40, 49, 50, 41],
        0x7E7D: [40, 51, 49, 41]
    },
    gaiji_2: {
        0x7521: [129, 172],
        0x7522: [129, 172],
        0x7523: [129, 172],
        0x7524: [129, 172],
        0x7525: [250, 113],
        0x7526: [250, 97],
        0x7527: [129, 172],
        0x7528: [129, 172],
        0x7529: [129, 172],
        0x752A: [129, 172],
        0x752B: [250, 138],
        0x752C: [129, 172],
        0x752D: [129, 172],
        0x752E: [251, 165],
        0x752F: [129, 172],
        0x7530: [129, 172],
        0x7531: [129, 172],
        0x7532: [129, 172],
        0x7533: [250, 147],
        0x7534: [129, 172],
        0x7535: [129, 172],
        0x7536: [129, 172],
        0x7537: [129, 172],
        0x7538: [129, 172],
        0x7539: [129, 172],
        0x753A: [250, 156],
        0x753B: [129, 172],
        0x753C: [129, 172],
        0x753D: [129, 172],
        0x753E: [129, 172],
        0x753F: [250, 170],
        0x7540: [250, 177],
        0x7541: [129, 172],
        0x7542: [129, 172],
        0x7543: [250, 184],
        0x7544: [250, 103],
        0x7545: [250, 186],
        0x7546: [129, 172],
        0x7547: [129, 172],
        0x7548: [250, 197],
        0x7549: [250, 212],
        0x754A: [129, 172],
        0x754B: [143, 140],
        0x754C: [250, 222],
        0x754D: [250, 102],
        0x754E: [129, 172],
        0x754F: [129, 172],
        0x7550: [129, 172],
        0x7551: [129, 172],
        0x7552: [129, 172],
        0x7553: [129, 172],
        0x7554: [139, 249],
        0x7555: [129, 172],
        0x7556: [129, 172],
        0x7557: [129, 172],
        0x7558: [129, 172],
        0x7559: [129, 172],
        0x755A: [129, 172],
        0x755B: [129, 172],
        0x755C: [129, 172],
        0x755D: [129, 172],
        0x755E: [129, 172],
        0x755F: [129, 172],
        0x7560: [129, 172],
        0x7561: [129, 172],
        0x7562: [129, 172],
        0x7563: [129, 172],
        0x7564: [129, 172],
        0x7565: [251, 87],
        0x7566: [251, 89],
        0x7567: [129, 172],
        0x7568: [129, 172],
        0x7569: [129, 172],
        0x756A: [251, 97],
        0x756B: [251, 98],
        0x756C: [129, 172],
        0x756D: [129, 172],
        0x756E: [129, 172],
        0x756F: [251, 103],
        0x7570: [251, 104],
        0x7571: [129, 172],
        0x7572: [129, 172],
        0x7573: [129, 172],
        0x7574: [129, 172],
        0x7575: [129, 172],
        0x7576: [129, 172],
        0x7577: [129, 172],
        0x7578: [129, 172],
        0x7579: [129, 172],
        0x757A: [129, 172],
        0x757B: [139, 95],
        0x757C: [226, 88],
        0x757D: [129, 172],
        0x757E: [129, 172],
        0x7621: [129, 172],
        0x7622: [129, 172],
        0x7623: [129, 172],
        0x7624: [129, 172],
        0x7625: [129, 172],
        0x7626: [129, 172],
        0x7627: [129, 172],
        0x7628: [251, 145],
        0x7629: [129, 172],
        0x762A: [129, 172],
        0x762B: [129, 172],
        0x762C: [129, 172],
        0x762D: [138, 139],
        0x762E: [250, 96],
        0x762F: [150, 72],
        0x7630: [251, 155],
        0x7631: [129, 172],
        0x7632: [144, 73],
        0x7633: [129, 172],
        0x7634: [129, 172],
        0x7635: [251, 162],
        0x7636: [138, 112],
        0x7637: [251, 170],
        0x7638: [129, 172],
        0x7639: [146, 210],
        0x763A: [129, 172],
        0x763B: [129, 172],
        0x763C: [251, 185],
        0x763D: [147, 65],
        0x763E: [129, 172],
        0x763F: [129, 172],
        0x7640: [250, 95],
        0x7641: [251, 216],
        0x7642: [250, 94],
        0x7643: [251, 232],
        0x7644: [129, 172],
        0x7645: [233, 76],
        0x7646: [129, 172],
        0x7647: [251, 252],
        0x7648: [142, 73],
        0x7649: [129, 172],
        0x764A: [129, 172],
        0x764B: [129, 172]
    },
    gaiji_1_unicode: {
        0x7A21: "\u{000026CC}",
        0x7A22: "\u{000026CD}",
        0x7A23: "\u{00002757}",
        0x7A24: "\u{000026CF}",
        0x7A25: "\u{000026D0}",
        0x7A26: "\u{000026D1}",
        0x7A28: "\u{000026D2}",
        0x7A29: "\u{000026D5}",
        0x7A2A: "\u{000026D3}",
        0x7A2B: "\u{000026D4}",
        0x7A30: "\u{0001F17F}",
        0x7A31: "\u{0001F18A}",
        0x7A34: "\u{000026D6}",
        0x7A35: "\u{000026D7}",
        0x7A36: "\u{000026D8}",
        0x7A37: "\u{000026D9}",
        0x7A38: "\u{000026DA}",
        0x7A39: "\u{000026DB}",
        0x7A3A: "\u{000026DC}",
        0x7A3B: "\u{000026DD}",
        0x7A3C: "\u{000026DE}",
        0x7A3D: "\u{000026DF}",
        0x7A3E: "\u{000026E0}",
        0x7A3F: "\u{000026E1}",
        0x7A40: "\u{00002B55}",
        0x7A41: "\u{00003248}",
        0x7A42: "\u{00003249}",
        0x7A43: "\u{0000324A}",
        0x7A44: "\u{0000324B}",
        0x7A45: "\u{0000324C}",
        0x7A46: "\u{0000324D}",
        0x7A47: "\u{0000324E}",
        0x7A48: "\u{0000324F}",
        0x7A4D: "\u{00002491}",
        0x7A4E: "\u{00002492}",
        0x7A4F: "\u{00002493}",
        0x7A50: "\u{0001F14A}",
        0x7A51: "\u{0001F14C}",
        0x7A52: "\u{0001F13F}",
        0x7A53: "\u{0001F146}",
        0x7A54: "\u{0001F14B}",
        0x7A55: "\u{0001F210}",
        0x7A56: "\u{0001F211}",
        0x7A57: "\u{0001F212}",
        0x7A58: "\u{0001F213}",
        0x7A59: "\u{0001F142}",
        0x7A5A: "\u{0001F214}",
        0x7A5B: "\u{0001F215}",
        0x7A5C: "\u{0001F216}",
        0x7A5D: "\u{0001F14D}",
        0x7A5E: "\u{0001F131}",
        0x7A5F: "\u{0001F13D}",
        0x7A60: "\u{00002B1B}",
        0x7A61: "\u{00002B24}",
        0x7A62: "\u{0001F217}",
        0x7A63: "\u{0001F218}",
        0x7A64: "\u{0001F219}",
        0x7A65: "\u{0001F21A}",
        0x7A66: "\u{0001F21B}",
        0x7A67: "\u{000026BF}",
        0x7A68: "\u{0001F21C}",
        0x7A69: "\u{0001F21D}",
        0x7A6A: "\u{0001F21E}",
        0x7A6B: "\u{0001F21F}",
        0x7A6C: "\u{0001F220}",
        0x7A6D: "\u{0001F221}",
        0x7A6E: "\u{0001F222}",
        0x7A6F: "\u{0001F223}",
        0x7A70: "\u{0001F224}",
        0x7A71: "\u{0001F225}",
        0x7A72: "\u{0001F14E}",
        0x7A73: "\u{00003299}",
        0x7A74: "\u{0001F200}",
        0x7B21: "\u{000026E3}",
        0x7B22: "\u{00002B56}",
        0x7B23: "\u{00002B57}",
        0x7B24: "\u{00002B58}",
        0x7B25: "\u{00002B59}",
        0x7B26: "\u{00002613}",
        0x7B27: "\u{0000328B}",
        0x7B28: "\u{00003012}",
        0x7B29: "\u{000026E8}",
        0x7B2A: "\u{00003246}",
        0x7B2B: "\u{00003245}",
        0x7B2C: "\u{000026E9}",
        0x7B2D: "\u{00000FD6}",
        0x7B2E: "\u{000026EA}",
        0x7B2F: "\u{000026EB}",
        0x7B30: "\u{000026EC}",
        0x7B31: "\u{00002668}",
        0x7B32: "\u{000026ED}",
        0x7B33: "\u{000026EE}",
        0x7B34: "\u{000026EF}",
        0x7B35: "\u{00002693}",
        0x7B36: "\u{00002708}",
        0x7B37: "\u{000026F0}",
        0x7B38: "\u{000026F1}",
        0x7B39: "\u{000026F2}",
        0x7B3A: "\u{000026F3}",
        0x7B3B: "\u{000026F4}",
        0x7B3C: "\u{000026F5}",
        0x7B3D: "\u{0001F157}",
        0x7B3E: "\u{000024B9}",
        0x7B3F: "\u{000024C8}",
        0x7B40: "\u{000026F6}",
        0x7B41: "\u{0001F15F}",
        0x7B42: "\u{0001F18B}",
        0x7B43: "\u{0001F18D}",
        0x7B44: "\u{0001F18C}",
        0x7B45: "\u{0001F179}",
        0x7B46: "\u{000026F7}",
        0x7B47: "\u{000026F8}",
        0x7B48: "\u{000026F9}",
        0x7B49: "\u{000026FA}",
        0x7B4A: "\u{0001F17B}",
        0x7B4B: "\u{0000260E}",
        0x7B4C: "\u{000026FB}",
        0x7B4D: "\u{000026FC}",
        0x7B4E: "\u{000026FD}",
        0x7B4F: "\u{000026FE}",
        0x7B50: "\u{0001F17C}",
        0x7B51: "\u{000026FF}",
        0x7C21: "\u{000027A1}",
        0x7C22: "\u{00002B05}",
        0x7C23: "\u{00002B06}",
        0x7C24: "\u{00002B07}",
        0x7C25: "\u{00002B2F}",
        0x7C26: "\u{00002B2E}",
        0x7C27: "\u{00005E74}",
        0x7C28: "\u{00006708}",
        0x7C29: "\u{000065E5}",
        0x7C2A: "\u{00005186}",
        0x7C2B: "\u{000033A1}",
        0x7C2C: "\u{000033A5}",
        0x7C2D: "\u{0000339D}",
        0x7C2E: "\u{000033A0}",
        0x7C2F: "\u{000033A4}",
        0x7C30: "\u{0001F100}",
        0x7C31: "\u{00002488}",
        0x7C32: "\u{00002489}",
        0x7C33: "\u{0000248A}",
        0x7C34: "\u{0000248B}",
        0x7C35: "\u{0000248C}",
        0x7C36: "\u{0000248D}",
        0x7C37: "\u{0000248E}",
        0x7C38: "\u{0000248F}",
        0x7C39: "\u{00002490}",
        0x7C3A: "\u{0000E290}",
        0x7C3B: "\u{0000E291}",
        0x7C3C: "\u{0000E292}",
        0x7C3D: "\u{0000E293}",
        0x7C3E: "\u{0000E294}",
        0x7C3F: "\u{0000E295}",
        0x7C40: "\u{0001F101}",
        0x7C41: "\u{0001F102}",
        0x7C42: "\u{0001F103}",
        0x7C43: "\u{0001F104}",
        0x7C44: "\u{0001F105}",
        0x7C45: "\u{0001F106}",
        0x7C46: "\u{0001F107}",
        0x7C47: "\u{0001F108}",
        0x7C48: "\u{0001F109}",
        0x7C49: "\u{0001F10A}",
        0x7C4A: "\u{00003233}",
        0x7C4B: "\u{00003236}",
        0x7C4C: "\u{00003232}",
        0x7C4D: "\u{00003231}",
        0x7C4E: "\u{00003239}",
        0x7C4F: "\u{00003244}",
        0x7C50: "\u{000025B6}",
        0x7C51: "\u{000025C0}",
        0x7C52: "\u{00003016}",
        0x7C53: "\u{00003017}",
        0x7C54: "\u{000027D0}",
        0x7C55: "\u{000000B2}",
        0x7C56: "\u{000000B3}",
        0x7C57: "\u{0001F12D}",
        0x7C58: "\u{0000E2A5}",
        0x7C59: "\u{0000E2A6}",
        0x7C5A: "\u{0000E2A7}",
        0x7C5B: "\u{0000E2A8}",
        0x7C5C: "\u{0000E2A9}",
        0x7C5D: "\u{0000E2AA}",
        0x7C5E: "\u{0000E2AB}",
        0x7C5F: "\u{0000E2AC}",
        0x7C60: "\u{0000E2AD}",
        0x7C61: "\u{0000E2AE}",
        0x7C62: "\u{0000E2AF}",
        0x7C63: "\u{0000E2B0}",
        0x7C64: "\u{0000E2B1}",
        0x7C65: "\u{0000E2B2}",
        0x7C66: "\u{0000E2B3}",
        0x7C67: "\u{0000E2B4}",
        0x7C68: "\u{0000E2B5}",
        0x7C69: "\u{0000E2B6}",
        0x7C6A: "\u{0000E2B7}",
        0x7C6B: "\u{0000E2B8}",
        0x7C6C: "\u{0000E2B9}",
        0x7C6D: "\u{0000E2BA}",
        0x7C6E: "\u{0000E2BB}",
        0x7C6F: "\u{0000E2BC}",
        0x7C70: "\u{0000E2BD}",
        0x7C71: "\u{0000E2BE}",
        0x7C72: "\u{0000E2BF}",
        0x7C73: "\u{0000E2C0}",
        0x7C74: "\u{0000E2C1}",
        0x7C75: "\u{0000E2C2}",
        0x7C76: "\u{0001F12C}",
        0x7C77: "\u{0001F12B}",
        0x7C78: "\u{00003247}",
        0x7C79: "\u{0001F190}",
        0x7C7A: "\u{0001F226}",
        0x7C7B: "\u{0000213B}",
        0x7D21: "\u{0000322A}",
        0x7D22: "\u{0000322B}",
        0x7D23: "\u{0000322C}",
        0x7D24: "\u{0000322D}",
        0x7D25: "\u{0000322E}",
        0x7D26: "\u{0000322F}",
        0x7D27: "\u{00003230}",
        0x7D28: "\u{00003237}",
        0x7D29: "\u{0000337E}",
        0x7D2A: "\u{0000337D}",
        0x7D2B: "\u{0000337C}",
        0x7D2C: "\u{0000337B}",
        0x7D2D: "\u{00002116}",
        0x7D2E: "\u{00002121}",
        0x7D2F: "\u{00003036}",
        0x7D30: "\u{000026BE}",
        0x7D31: "\u{0001F240}",
        0x7D32: "\u{0001F241}",
        0x7D33: "\u{0001F242}",
        0x7D34: "\u{0001F243}",
        0x7D35: "\u{0001F244}",
        0x7D36: "\u{0001F245}",
        0x7D37: "\u{0001F246}",
        0x7D38: "\u{0001F247}",
        0x7D39: "\u{0001F248}",
        0x7D3A: "\u{0001F12A}",
        0x7D3B: "\u{0001F227}",
        0x7D3C: "\u{0001F228}",
        0x7D3D: "\u{0001F229}",
        0x7D3E: "\u{0001F214}",
        0x7D3F: "\u{0001F22A}",
        0x7D40: "\u{0001F22B}",
        0x7D41: "\u{0001F22C}",
        0x7D42: "\u{0001F22D}",
        0x7D43: "\u{0001F22E}",
        0x7D44: "\u{0001F22F}",
        0x7D45: "\u{0001F230}",
        0x7D46: "\u{0001F231}",
        0x7D47: "\u{00002113}",
        0x7D48: "\u{0000338F}",
        0x7D49: "\u{00003390}",
        0x7D4A: "\u{000033CA}",
        0x7D4B: "\u{0000339E}",
        0x7D4C: "\u{000033A2}",
        0x7D4D: "\u{00003371}",
        0x7D50: "\u{000000BD}",
        0x7D51: "\u{00002189}",
        0x7D52: "\u{00002153}",
        0x7D53: "\u{00002154}",
        0x7D54: "\u{000000BC}",
        0x7D55: "\u{000000BE}",
        0x7D56: "\u{00002155}",
        0x7D57: "\u{00002156}",
        0x7D58: "\u{00002157}",
        0x7D59: "\u{00002158}",
        0x7D5A: "\u{00002159}",
        0x7D5B: "\u{0000215A}",
        0x7D5C: "\u{00002150}",
        0x7D5D: "\u{0000215B}",
        0x7D5E: "\u{00002151}",
        0x7D5F: "\u{00002152}",
        0x7D60: "\u{00002600}",
        0x7D61: "\u{00002601}",
        0x7D62: "\u{00002602}",
        0x7D63: "\u{000026C4}",
        0x7D64: "\u{00002616}",
        0x7D65: "\u{00002617}",
        0x7D66: "\u{000026C9}",
        0x7D67: "\u{000026CA}",
        0x7D68: "\u{00002666}",
        0x7D69: "\u{00002665}",
        0x7D6A: "\u{00002663}",
        0x7D6B: "\u{00002660}",
        0x7D6C: "\u{000026CB}",
        0x7D6D: "\u{00002A00}",
        0x7D6E: "\u{0000203C}",
        0x7D6F: "\u{00002049}",
        0x7D70: "\u{000026C5}",
        0x7D71: "\u{00002614}",
        0x7D72: "\u{000026C6}",
        0x7D73: "\u{00002603}",
        0x7D74: "\u{000026C7}",
        0x7D75: "\u{000026A1}",
        0x7D76: "\u{000026C8}",
        0x7D78: "\u{0000269E}",
        0x7D79: "\u{0000269F}",
        0x7D7A: "\u{0000266C}",
        0x7D7B: "\u{0000260E}",
        0x7E21: "\u{00002160}",
        0x7E22: "\u{00002161}",
        0x7E23: "\u{00002162}",
        0x7E24: "\u{00002163}",
        0x7E25: "\u{00002164}",
        0x7E26: "\u{00002165}",
        0x7E27: "\u{00002166}",
        0x7E28: "\u{00002167}",
        0x7E29: "\u{00002168}",
        0x7E2A: "\u{00002169}",
        0x7E2B: "\u{0000216A}",
        0x7E2C: "\u{0000216B}",
        0x7E2D: "\u{00002470}",
        0x7E2E: "\u{00002471}",
        0x7E2F: "\u{00002472}",
        0x7E30: "\u{00002473}",
        0x7E31: "\u{00002474}",
        0x7E32: "\u{00002475}",
        0x7E33: "\u{00002476}",
        0x7E34: "\u{00002477}",
        0x7E35: "\u{00002478}",
        0x7E36: "\u{00002479}",
        0x7E37: "\u{0000247A}",
        0x7E38: "\u{0000247B}",
        0x7E39: "\u{0000247C}",
        0x7E3A: "\u{0000247D}",
        0x7E3B: "\u{0000247E}",
        0x7E3C: "\u{0000247F}",
        0x7E3D: "\u{00003251}",
        0x7E3E: "\u{00003252}",
        0x7E3F: "\u{00003253}",
        0x7E40: "\u{00003254}",
        0x7E41: "\u{0001F110}",
        0x7E42: "\u{0001F111}",
        0x7E43: "\u{0001F112}",
        0x7E44: "\u{0001F113}",
        0x7E45: "\u{0001F114}",
        0x7E46: "\u{0001F115}",
        0x7E47: "\u{0001F116}",
        0x7E48: "\u{0001F117}",
        0x7E49: "\u{0001F118}",
        0x7E4A: "\u{0001F119}",
        0x7E4B: "\u{0001F11A}",
        0x7E4C: "\u{0001F11B}",
        0x7E4D: "\u{0001F11C}",
        0x7E4E: "\u{0001F11D}",
        0x7E4F: "\u{0001F11E}",
        0x7E50: "\u{0001F11F}",
        0x7E51: "\u{0001F120}",
        0x7E52: "\u{0001F121}",
        0x7E53: "\u{0001F122}",
        0x7E54: "\u{0001F123}",
        0x7E55: "\u{0001F124}",
        0x7E56: "\u{0001F125}",
        0x7E57: "\u{0001F126}",
        0x7E58: "\u{0001F127}",
        0x7E59: "\u{0001F128}",
        0x7E5A: "\u{0001F129}",
        0x7E5B: "\u{00003255}",
        0x7E5C: "\u{00003256}",
        0x7E5D: "\u{00003257}",
        0x7E5E: "\u{00003258}",
        0x7E5F: "\u{00003259}",
        0x7E60: "\u{0000325A}",
        0x7E61: "\u{00002460}",
        0x7E62: "\u{00002461}",
        0x7E63: "\u{00002462}",
        0x7E64: "\u{00002463}",
        0x7E65: "\u{00002464}",
        0x7E66: "\u{00002465}",
        0x7E67: "\u{00002466}",
        0x7E68: "\u{00002467}",
        0x7E69: "\u{00002468}",
        0x7E6A: "\u{00002469}",
        0x7E6B: "\u{0000246A}",
        0x7E6C: "\u{0000246B}",
        0x7E6D: "\u{0000246C}",
        0x7E6E: "\u{0000246D}",
        0x7E6F: "\u{0000246E}",
        0x7E70: "\u{0000246F}",
        0x7E71: "\u{00002776}",
        0x7E72: "\u{00002777}",
        0x7E73: "\u{00002778}",
        0x7E74: "\u{00002779}",
        0x7E75: "\u{0000277A}",
        0x7E76: "\u{0000277B}",
        0x7E77: "\u{0000277C}",
        0x7E78: "\u{0000277D}",
        0x7E79: "\u{0000277E}",
        0x7E7A: "\u{0000277F}",
        0x7E7B: "\u{000024EB}",
        0x7E7C: "\u{000024EC}",
        0x7E7D: "\u{0000325B}"
    },
    gaiji_2_unicode: {
        0x7521: "\u{00003402}",
        0x7522: "\u{00020158}",
        0x7523: "\u{00004EFD}",
        0x7524: "\u{00004EFF}",
        0x7525: "\u{00004F9A}",
        0x7526: "\u{00004FC9}",
        0x7527: "\u{0000509C}",
        0x7528: "\u{0000511E}",
        0x7529: "\u{000051BC}",
        0x752A: "\u{0000351F}",
        0x752B: "\u{00005307}",
        0x752C: "\u{00005361}",
        0x752D: "\u{0000536C}",
        0x752E: "\u{00008A79}",
        0x752F: "\u{00020BB7}",
        0x7530: "\u{0000544D}",
        0x7531: "\u{00005496}",
        0x7532: "\u{0000549C}",
        0x7533: "\u{000054A9}",
        0x7534: "\u{0000550E}",
        0x7535: "\u{0000554A}",
        0x7536: "\u{00005672}",
        0x7537: "\u{000056E4}",
        0x7538: "\u{00005733}",
        0x7539: "\u{00005734}",
        0x753A: "\u{0000FA10}",
        0x753B: "\u{00005880}",
        0x753C: "\u{000059E4}",
        0x753D: "\u{00005A23}",
        0x753E: "\u{00005A55}",
        0x753F: "\u{00005BEC}",
        0x7540: "\u{0000FA11}",
        0x7541: "\u{000037E2}",
        0x7542: "\u{00005EAC}",
        0x7543: "\u{00005F34}",
        0x7544: "\u{00005F45}",
        0x7545: "\u{00005FB7}",
        0x7546: "\u{00006017}",
        0x7547: "\u{0000FA6B}",
        0x7548: "\u{00006130}",
        0x7549: "\u{00006624}",
        0x754A: "\u{000066C8}",
        0x754B: "\u{000066D9}",
        0x754C: "\u{000066FA}",
        0x754D: "\u{000066FB}",
        0x754E: "\u{00006852}",
        0x754F: "\u{00009FC4}",
        0x7550: "\u{00006911}",
        0x7551: "\u{0000693B}",
        0x7552: "\u{00006A45}",
        0x7553: "\u{00006A91}",
        0x7554: "\u{00006ADB}",
        0x7555: "\u{000233CC}",
        0x7556: "\u{000233FE}",
        0x7557: "\u{000235C4}",
        0x7558: "\u{00006BF1}",
        0x7559: "\u{00006CE0}",
        0x755A: "\u{00006D2E}",
        0x755B: "\u{0000FA45}",
        0x755C: "\u{00006DBF}",
        0x755D: "\u{00006DCA}",
        0x755E: "\u{00006DF8}",
        0x755F: "\u{0000FA46}",
        0x7560: "\u{00006F5E}",
        0x7561: "\u{00006FF9}",
        0x7562: "\u{00007064}",
        0x7563: "\u{0000FA6C}",
        0x7564: "\u{000242EE}",
        0x7565: "\u{00007147}",
        0x7566: "\u{000071C1}",
        0x7567: "\u{00007200}",
        0x7568: "\u{0000739F}",
        0x7569: "\u{000073A8}",
        0x756A: "\u{000073C9}",
        0x756B: "\u{000073D6}",
        0x756C: "\u{0000741B}",
        0x756D: "\u{00007421}",
        0x756E: "\u{0000FA4A}",
        0x756F: "\u{00007426}",
        0x7570: "\u{0000742A}",
        0x7571: "\u{0000742C}",
        0x7572: "\u{00007439}",
        0x7573: "\u{0000744B}",
        0x7574: "\u{00003EDA}",
        0x7575: "\u{00007575}",
        0x7576: "\u{00007581}",
        0x7577: "\u{00007772}",
        0x7578: "\u{00004093}",
        0x7579: "\u{000078C8}",
        0x757A: "\u{000078E0}",
        0x757B: "\u{00007947}",
        0x757C: "\u{000079AE}",
        0x757D: "\u{00009FC6}",
        0x757E: "\u{00004103}",
        0x7621: "\u{00009FC5}",
        0x7622: "\u{000079DA}",
        0x7623: "\u{00007A1E}",
        0x7624: "\u{00007B7F}",
        0x7625: "\u{00007C31}",
        0x7626: "\u{00004264}",
        0x7627: "\u{00007D8B}",
        0x7628: "\u{00007FA1}",
        0x7629: "\u{00008118}",
        0x762A: "\u{0000813A}",
        0x762B: "\u{0000FA6D}",
        0x762C: "\u{000082AE}",
        0x762D: "\u{0000845B}",
        0x762E: "\u{000084DC}",
        0x762F: "\u{000084EC}",
        0x7630: "\u{00008559}",
        0x7631: "\u{000085CE}",
        0x7632: "\u{00008755}",
        0x7633: "\u{000087EC}",
        0x7634: "\u{0000880B}",
        0x7635: "\u{000088F5}",
        0x7636: "\u{000089D2}",
        0x7637: "\u{00008AF6}",
        0x7638: "\u{00008DCE}",
        0x7639: "\u{00008FBB}",
        0x763A: "\u{00008FF6}",
        0x763B: "\u{000090DD}",
        0x763C: "\u{00009127}",
        0x763D: "\u{0000912D}",
        0x763E: "\u{000091B2}",
        0x763F: "\u{00009233}",
        0x7640: "\u{00009288}",
        0x7641: "\u{00009321}",
        0x7642: "\u{00009348}",
        0x7643: "\u{00009592}",
        0x7644: "\u{000096DE}",
        0x7645: "\u{00009903}",
        0x7646: "\u{00009940}",
        0x7647: "\u{00009AD9}",
        0x7648: "\u{00009BD6}",
        0x7649: "\u{00009DD7}",
        0x764A: "\u{00009EB4}",
        0x764B: "\u{00009EB5}",
    },
};
module.exports = charTable;
//# sourceMappingURL=char_table.js.map